import { useEffect, useState } from 'react'

interface TelegramUser {
  id: number
  first_name: string
  last_name?: string
  username?: string
  photo_url?: string
}

declare global {
  interface Window {
    Telegram?: {
      WebApp: {
        initDataUnsafe?: {
          user?: TelegramUser
        }
        ready: () => void
        expand: () => void
        close: () => void
        showAlert: (message: string) => void
        showConfirm: (message: string, callback: (confirmed: boolean) => void) => void
      }
    }
  }
}

export const useTelegram = () => {
  const [webApp, setWebApp] = useState<Window['Telegram'] | null>(null)
  const [user, setUser] = useState<TelegramUser | null>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const tg = window.Telegram
    
    if (tg?.WebApp) {
      tg.WebApp.ready()
      tg.WebApp.expand()
      setWebApp(tg)
      setUser(tg.WebApp.initDataUnsafe?.user || null)
      setIsReady(true)
    } else {
      // Для разработки вне Telegram
      setIsReady(true)
    }
  }, [])

  const showAlert = (message: string) => {
    webApp?.WebApp.showAlert(message)
  }

  const showConfirm = (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      webApp?.WebApp.showConfirm(message, (confirmed: boolean) => {
        resolve(confirmed || false)
      })
    })
  }

  const close = () => {
    webApp?.WebApp.close()
  }

  return {
    webApp,
    user,
    isReady,
    showAlert,
    showConfirm,
    close,
  }
}

